import React, { Component } from "react";
import Box from '@mui/material/Box';
import * as Const from "../Constant";

import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Grid from '@mui/material/Grid';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import Paper from '@mui/material/Paper';
import Slider from '@mui/material/Slider';
import Alert from '@mui/material/Alert';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Snackbar from '@mui/material/Snackbar';
import Drawer from '@mui/material/Drawer';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import DialogAide from "./DialogAide";
import Checkbox from '@mui/material/Checkbox';


export default class FiltrePronosticsSynthese extends Component {
  constructor(props) {
    super(props);
    this.state = {
      utilisateur:this.props.utilisateur,
      dossier:"Bases",
      label:"",
      aideFiltre: false
    };
    
  }


  aideFiltre = () => {
    this.setState({ aideFiltre: true})
  }

  closeAideFiltre = () => {
    this.setState({ aideFiltre: false})
  }

  componentWillReceiveProps(props) {
    this.setState({ utilisateur: props.utilisateur})
  }

  componentDidMount() {
    this.getDossiers();
  }

  

  handleSelect = (event) => {
    this.setState({ dossier: event.target.value});
    this.props.filtres(event.target.value)
  }

   getDossiers = () => {
          fetch(
            Const.URL_WS_DOSSIERS + `?utilisateur=${localStorage.getItem("utilisateur_dtf")}`,
            { retry: 0, retryDelay: 1000 }
          )
            .then((res) => res.json())
            .then((data) => {
              this.setState({ dossiers: data})
            })
            .catch((error) => {
              console.log("Request failed", error);
            });
        }


  /************************************************************************************
   * RENDU
   ***********************************************************************************/

  render() {

    return(
      <div>

    {this.state.aideFiltre && (
    <DialogAide titre={"Astuce"} open={true} close={this.closeAideFiltre}
    content={<span class="lato-regular" style={{fontSize:"15px"}}>
      
      <b>
      1 - Choississez votre Synthèse :
      </b>
      <br/><br/>
      Choisissez une synthèse pour voir les pronostics associés.
      <br/><br/>
     
      </span>}
    />
    )}

      <Card>
      <CardHeader
          avatar={
          <Avatar aria-label="recipe">
              F
          </Avatar>
          }
          action={
          <div>
         
              <HelpOutlineOutlinedIcon onClick={this.aideFiltre}  style={{color:"black", margin:"0.3em", cursor:"pointer"}}/>
         
         
          </div>
          }
          title={<span class="lato-bold" style={{transform:"none", color:"black", fontSize:"15px"}}>Filtres</span>}
          subheader={<span class="lato-regular" style={{fontSize:"14px"}} >Choississez votre synthèse.</span>}
      />
      <CardContent>
     
      <FormControl fullWidth style={{ marginBottom:"1em"}}>
                  <InputLabel id="demo-simple-select-label"><span style={{color:"black"}} class="lato-regular">Dossier</span></InputLabel>
                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={this.state.dossier}
                    label="Dossier"
                    defaultValue={"Pronostics Trotstats"}
                    onChange={this.handleSelect}
                  >
                  <MenuItem value={"Bases"}><span class="lato-regular" style={{fontSize:"14px"}}>Synthèse personnalisée</span></MenuItem>
                  <MenuItem value={"Test"}><span class="lato-regular" style={{fontSize:"14px"}}>Synthèse personnalisée - Test</span></MenuItem>
                  <MenuItem value={"Archive"}><span class="lato-regular" style={{fontSize:"14px"}}>Synthèse personnalisée - Archive</span></MenuItem>

                  
                  {this.state.dossiers != null && this.state.dossiers.map((o, index) => (
                    <MenuItem value={o.key}><span class="lato-regular" style={{fontSize:"14px"}}>Synthèse {o.label}</span></MenuItem>
                  ))}
                  
                  </Select>
        </FormControl>

      </CardContent>
      </Card>

     
      </div>


    )
  }
}